import { dropRightWhile } from 'lodash';
import { stats } from '@fiverr-private/obs';
import { STATS_METRIC_PREFIX_PACKAGE_NAME } from '../../constants';
import type { ReportData } from '../../modern/components/CategoriesNavigation/transformer/types';

export const CATEGORIES_NAVIGATION_STATS_PREFIX = `${STATS_METRIC_PREFIX_PACKAGE_NAME}.categories_navigation`;

export enum CategoriesNavigationMetric {
    OPEN = 'open',
    CLOSE = 'close',
    SECTION_CLICK = 'section_click',
    CATEGORY_CLICK = 'category_click',
    LINK_CLICK = 'link_click',
    EXPLORE_CLICK = 'explore_click',
}

const MISSING_ID = 'none';

const buildIdsPath = ({ categoryId, subCategoryId, nestedSubCategoryId }: Omit<ReportData, 'alias'> = {}) =>
    dropRightWhile(
        [categoryId, subCategoryId, nestedSubCategoryId].map((id) => id || MISSING_ID),
        (id) => id === MISSING_ID
    ).join('.');

export const countCategoriesNavigation = (metric: CategoriesNavigationMetric, reportData?: ReportData) => {
    const idsPath = buildIdsPath(reportData);

    return stats.count(CATEGORIES_NAVIGATION_STATS_PREFIX, idsPath ? `${metric}.${idsPath}` : metric);
};
